import { Chip } from "@mui/material";
import {
  MenuBook,
  Calculate,
  Psychology,
  Visibility,
} from "@mui/icons-material";

/**
 * Styling keyed by Master Form `subjects.key` (see SubjectSeeder / `subjects` table).
 */
export const SUBJECT_STYLE_BY_KEY = {
  maths: {
    label: "Maths",
    color: "#2e7d32",
    bg: "#e8f5e9",
    icon: <Calculate sx={{ fontSize: 14 }} />,
  },
  english: {
    label: "English",
    color: "#1565c0",
    bg: "#e3f2fd",
    icon: <MenuBook sx={{ fontSize: 14 }} />,
  },
  "verbal-reasoning": {
    label: "Verbal Reasoning",
    color: "#6a1b9a",
    bg: "#f3e5f5",
    icon: <Psychology sx={{ fontSize: 14 }} />,
  },
  "non-verbal-reasoning": {
    label: "Non-Verbal Reasoning",
    color: "#e65100",
    bg: "#fff3e0",
    icon: <Visibility sx={{ fontSize: 14 }} />,
  },
};

/** Legacy uppercase strings still used on `question_bank_imports.exam_subject` (AI pipeline). */
export const LEGACY_EXAM_SUBJECT_STYLE = {
  ENGLISH: {
    label: "English",
    color: "#1565c0",
    bg: "#e3f2fd",
    icon: <MenuBook sx={{ fontSize: 14 }} />,
  },
  MATHEMATICS: {
    label: "Maths",
    color: "#2e7d32",
    bg: "#e8f5e9",
    icon: <Calculate sx={{ fontSize: 14 }} />,
  },
  "VERBAL REASONING": {
    label: "Verbal Reasoning",
    color: "#6a1b9a",
    bg: "#f3e5f5",
    icon: <Psychology sx={{ fontSize: 14 }} />,
  },
  "NON-VERBAL REASONING": {
    label: "Non-Verbal Reasoning",
    color: "#e65100",
    bg: "#fff3e0",
    icon: <Visibility sx={{ fontSize: 14 }} />,
  },
};

/**
 * @param {object|string} subject — Master `{ id?, name, key }` from API, or legacy `exam_subject` string on imports.
 */
export const SubjectChip = ({ subject, size = "small", sx = {} }) => {
  if (subject == null || subject === "") return null;

  if (typeof subject === "object" && subject.key) {
    const cfg = SUBJECT_STYLE_BY_KEY[subject.key];
    const label = subject.name || cfg?.label || subject.key;
    if (!label) return null;
    return (
      <Chip
        icon={cfg?.icon}
        label={label}
        size={size}
        sx={{
          bgcolor: cfg?.bg ?? "#f5f5f5",
          color: cfg?.color ?? "#424242",
          fontWeight: 600,
          fontSize: size === "small" ? "0.68rem" : "0.75rem",
          height: size === "small" ? 20 : 24,
          "& .MuiChip-icon": { color: cfg?.color ?? "#424242", ml: 0.5 },
          ...sx,
        }}
      />
    );
  }

  if (typeof subject === "string") {
    const cfg = LEGACY_EXAM_SUBJECT_STYLE[subject];
    if (!cfg) {
      return (
        <Chip
          label={subject}
          size={size}
          variant="outlined"
          sx={{ fontSize: size === "small" ? "0.68rem" : "0.75rem", ...sx }}
        />
      );
    }
    return (
      <Chip
        icon={cfg.icon}
        label={cfg.label}
        size={size}
        sx={{
          bgcolor: cfg.bg,
          color: cfg.color,
          fontWeight: 600,
          fontSize: size === "small" ? "0.68rem" : "0.75rem",
          height: size === "small" ? 20 : 24,
          "& .MuiChip-icon": { color: cfg.color, ml: 0.5 },
          ...sx,
        }}
      />
    );
  }

  return null;
};

/** @deprecated Use SUBJECT_STYLE_BY_KEY / LEGACY_EXAM_SUBJECT_STYLE */
export const SUBJECT_CONFIG = LEGACY_EXAM_SUBJECT_STYLE;
